/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Rich_Calf_GazeInputs */

const en_flat_rich_calf_gaze = /** @type {(inputs: Flat_Rich_Calf_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const de_flat_rich_calf_gaze = /** @type {(inputs: Flat_Rich_Calf_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

/**
* | output |
* | --- |
* | "Aktiv" |
*
* @param {Flat_Rich_Calf_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_rich_calf_gaze = /** @type {((inputs?: Flat_Rich_Calf_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Rich_Calf_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_rich_calf_gaze(inputs)
	return de_flat_rich_calf_gaze(inputs)
});